import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory, useParams } from 'react-router';
import * as actions from '../../redux/actions';
import { useMemo } from 'react';
import { Tooltip, PieChart, Pie, Cell, ResponsiveContainer } from 'recharts';
import dayjs from 'dayjs';
import { ViewTitle } from '../../components/ViewTitle';
import { BackButton } from '../../components/Button';
export default function GoldDashboard({ title, subtitle }) {
  const [value, setValue] = useState(0);
  const dispatch = useDispatch();

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };
  const history = useHistory();
  const [name, setName] = useState('');
  const [page, setPage] = useState(1);
  const [size, setSize] = useState(50);
  const [date, setDate] = useState(dayjs());
  const [total, setTotal] = useState(undefined);
  const { id } = useParams();
  const place = useSelector((state) => state.place);
  const material = useSelector((state) => state.material);
  const materialType = useSelector((state) => state.materialType);

  const goldTransaction = useSelector((state) => state.gold);
  useEffect(() => {
    dispatch(actions.matrialReset());
    dispatch(actions.placeGet(id));
    dispatch(actions.materialTypeAll({}));
    dispatch(
      actions.goldTransactionAll({
        name: '',
        size: '',
        place: id,
        statusPlace: true,
      }),
    );
    return () => {};
  }, [name, size]);
  // ข้อมูลจำลองสำหรับทองแต่ละประเภท
  const renderTitle = () => (
    <ViewTitle title={`${title}${place?.name || ''} `} subtitle={subtitle} />
  );
  const allOrders = goldTransaction?.rows?.map((tx) => ({
    ...tx,
    gold_transaction_type: tx?.gold_transaction_type,
  }));
  const groupedBuySellByMaterialType = _.mapValues(
    _.groupBy(allOrders, (order) => order?.order?.material_type?.name),
    (orders) => {
      // แยกข้อมูลBUY
      const BUY = orders.filter(
        (order) => order?.gold_transaction_type === 'BUY',
      );
      // แยกข้อมูลSALE
      const SALE = orders.filter(
        (order) => order?.gold_transaction_type === 'SALE',
      );
      const buyCost = _.sumBy(BUY, 'totalCost');
      const saleCost = _.sumBy(SALE, 'totalCost');
      const buyWeight = _.sumBy(BUY, 'totalweight');
      const saleWeight = _.sumBy(SALE, 'totalweight');
      const totalWeight = buyWeight + saleWeight;
      const remainWeight = buyWeight - saleWeight;
      const costAverageBuy = buyCost / buyWeight || 0;
      const costAverageSale = saleCost / saleWeight || 0;
      const costAverageTotal = costAverageBuy + costAverageSale;
      const costProfit = saleCost - buyCost;
      const profitAveragre = (costProfit / saleCost) * 100 || 0;
      // const datasaleBuy =
      return {
        BUY,
        SALE,
        sumWeightByType: {
          buyWeight,
          saleWeight,
          totalWeight,
          remainWeight,
        },
        sumCostByType: {
          buyCost,
          saleCost,
          costProfit,
          profitAveragre,
        },
        costAverage: {
          buyCost: costAverageBuy,
          saleCost: costAverageSale,
          costTotal: costAverageTotal,
        },
      };
    },
  );
  const filteredGroups = _.filter(materialType?.rows, (type) =>
    _.has(groupedBuySellByMaterialType, type?.name),
  ).map((type) => ({
    typeName: type?.name,
    group: _.get(groupedBuySellByMaterialType, type?.name),
  }));
  const buytotalPayment = _.sumBy(
    _.filter(
      goldTransaction?.rows,
      (row) => row?.gold_transaction_type === 'BUY',
    ),
    (row) => row?.order?.cost,
  );

  const saletotalPayment = _.sumBy(
    _.filter(
      goldTransaction?.rows,
      (row) => row?.gold_transaction_type === 'SALE',
    ),
    (row) => row?.order?.cost,
  );

  const totalPayment = buytotalPayment + saletotalPayment;
  const buypercent = (buytotalPayment / totalPayment) * 100 || 0;
  const salepercent = (saletotalPayment / totalPayment) * 100 || 0;

  // ข้อมูลรวมทุกประเภททอง
  const categoryData = useMemo(
    () => [
      {
        name: 'ซื้อ',
        value: Number(((buytotalPayment / totalPayment) * 100).toFixed(2)) || 0,
        color: '#c6241c',
      },
      {
        name: 'ขาย',
        value:
          Number(((saletotalPayment / totalPayment) * 100).toFixed(2)) || 0,
        color: '#11cd22',
      },
    ],
    [buytotalPayment, saletotalPayment, totalPayment],
  );
  return (
    <div className="w-full bg-gray-50 p-4 font-sans">
      {renderTitle()}
      <BackButton />
      <h1 className="text-center text-2xl font-semibold text-amber-700 mb-6">
        แดชบอร์ดข้อมูลการขายทองตามเปอร์เซ็นต์
      </h1>
      <div className=" border-b border-amber-600 mb-4">
        <div className="flex justify-end">
          <h2
            className="cursor-pointer text-md text-blue-800 mb-2 underline"
            onClick={() => history.push('/gold/reportgold')}
            style={{ display: 'inline-block' }}
          ></h2>
        </div>
      </div>

      {filteredGroups.map(({ typeName, group }) => (
        <div>
          <h3 className="text-xl mb-4 font-bold   text-center">
            ประเภท {typeName}
          </h3>
          <div className="grid grid-cols-1 md:grid-cols-5 gap-5 mb-8">
            <div className="bg-white rounded-lg shadow p-4">
              <div className="text-blue-800">ราคาเฉลี่ย</div>
              <div className=" ">
                <div className="text-2xl fonts-bold">
                  {group?.costAverage?.costTotal?.toLocaleString()} บาท
                </div>
                <div className="flex">
                  <div className="md:text-md text-red-600 lg:text-lg pr-2">
                    {' '}
                    ราคาเฉลี่ยซื้อ:{' '}
                  </div>
                  <div className="md:text-md text-red-600 lg:text-lg">
                    {group?.costAverage?.buyCost?.toLocaleString()} บาท
                  </div>
                </div>
                <div className="flex">
                  <div className="md:text-md text-green-600 lg:text-lg pr-2">
                    {' '}
                    ราคาเฉลี่ยขาย:{' '}
                  </div>
                  <div className="md:text-md text-green-600 lg:text-lg">
                    {group?.costAverage?.saleCost?.toLocaleString()} บาท
                  </div>
                </div>
              </div>
            </div>

            <div className="bg-white rounded-lg shadow p-4">
              <div className="text-green-800">น้ำหนักรวม</div>
              <div className="">
                <div className="text-2xl ">
                  {group?.sumWeightByType?.totalWeight?.toLocaleString()} กรัม
                </div>
                <div className="flex">
                  <div className="md:text-md text-red-600 lg:text-lg pr-2">
                    {' '}
                    น้ำหนักซื้อ:{' '}
                  </div>
                  <div className="md:text-md text-red-600 lg:text-lg">
                    {group?.sumWeightByType?.buyWeight?.toLocaleString()} กรัม
                  </div>
                </div>
                <div className="flex">
                  <div className="md:text-md text-green-600 lg:text-lg pr-2">
                    {' '}
                    น้ำหนักขาย:{' '}
                  </div>
                  <div className="md:text-md text-green-600 lg:text-lg">
                    {group?.sumWeightByType?.saleWeight?.toLocaleString()} กรัม
                  </div>
                </div>
                <div className="flex">
                  <div className="md:text-md text-blue-600 lg:text-lg pr-2">
                    {' '}
                    น้ำหนักคงเหลือ:{' '}
                  </div>
                  <div className="md:text-md text-blue-600 lg:text-lg">
                    {group?.sumWeightByType?.remainWeight?.toLocaleString()}{' '}
                    กรัม
                  </div>
                </div>
              </div>
            </div>

            <div className="bg-white rounded-lg shadow p-4">
              <div className="text-amber-800">ต้นทุนรวม</div>
              <div className="text-2xl ">
                {group?.sumCostByType?.buyCost?.toLocaleString()} บาท
              </div>
            </div>
            <div className="bg-white rounded-lg shadow p-4">
              <div className="text-amber-800">ยอดขายรวม</div>
              <div className="text-2xl ">
                {group?.sumCostByType?.saleCost?.toLocaleString()} บาท
              </div>
            </div>

            <div className="bg-white rounded-lg shadow p-4">
              <div className="text-purple-800">กำไรรวม</div>
              <div className="text-2xl">
                {group?.sumCostByType?.costProfit?.toLocaleString()} บาท
              </div>
              <div className="text-sm text-purple-600">
                อัตรากำไร{' '}
                {group?.sumCostByType?.profitAveragre?.toLocaleString()} %
              </div>
            </div>
          </div>
        </div>
      ))}

      <div className="w-full  md:grid-cols-2 gap-8 mb-8">
        <div className="bg-white rounded-lg shadow p-4">
          <h3 className="mb-2">สัดส่วนการซื้อ-ขายสินค้า</h3>
          <div className="h-64">
            <ResponsiveContainer width="100%" height="100%">
              <PieChart>
                <Pie
                  data={categoryData}
                  cx="50%"
                  cy="50%"
                  outerRadius={80}
                  fill="#8884d8"
                  dataKey="value"
                  label={({ name, value }) => `${name} ${value}%`}
                >
                  {categoryData.map((entry, index) => (
                    <Cell key={`cell-${index}`} fill={entry.color} />
                  ))}
                </Pie>
                <Tooltip />
              </PieChart>
            </ResponsiveContainer>
          </div>
        </div>
      </div>
    </div>
  );
}
